import React, { useEffect, useState } from 'react';
import PDFViewer from './components/PDFViewer/PDFViewer';
import { SourceDocument } from './types';
import DOMPurify from 'dompurify';
import EclipseLoader from './SVG/EclipseLoader';

function App() {
    const [sourceDocument,setSourceDocument] = useState<SourceDocument |  undefined>(undefined)
    const [loadingText ,setLoadingText] = useState<string |  undefined>(undefined)

    useEffect(() => {
      const handleMessage = (event: any) => {


        try {
          const data = typeof event.data === 'string' ?  JSON.parse(event.data) : event.data;
          // Validate the origin

          if ( typeof data === 'string' || data.type !== 'mobile-message') {
            return;
          };
          // Sanitize the data
          const purify = DOMPurify(window);

          setSourceDocument({
            content: '',
            metadata: {
              page:  Number.parseInt(purify.sanitize(data.content.page)) ,
              source_pdf_preview_url: purify.sanitize(data.content.source_pdf_preview_url),
              source: purify.sanitize(data.content.source_url)
            }
          })
          setLoadingText(purify.sanitize(data.content.loadingText))
        } catch (e) {
          console.warn('Invalid JSON: ', event.data);
        }
      };

      window.addEventListener('message', handleMessage);
      document.addEventListener('message', handleMessage);

      return () => {
        document.removeEventListener('message', handleMessage);
        window.removeEventListener('message', handleMessage);
      };
    }, []);

  return (
    <div className="home" >
     {!sourceDocument ? (
          <div className="flex align-center justify-center full-height">
            <EclipseLoader
              color="#17b1e2"
              width="100"
              height="90vh"
            />
          </div>
     ): (
      <PDFViewer
        source={sourceDocument.metadata.source}
        previewSource={sourceDocument.metadata.source_pdf_preview_url}
        page={sourceDocument.metadata.page}
        loadingText={loadingText}
      />
     )}
    </div>
  );
}

export default App;
